import { lazy } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes, SyncHook } from '../route-types';

// Lazy load the GuideList component
const GuideList = lazy(() =>
  import('react-components/guide-list/guide-list').then(module => ({
    default: module.default,
  }))
);

export const GUIDE_PATH = '/guides';

const useSyncHook: SyncHook = null;

const routes: Routes = [
  {
    path: GUIDE_PATH,
    element: <GuideList />,
  },
];

const useNavigationHooks = () => {
  const navigate = useNavigate();
  return {
    toGuideList: () => {
      navigate(GUIDE_PATH);
    },
  };
};

export const guideListPageRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
